 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"active-tournament-catalog~app-layout~homeshop-tournament~instant-match-catalog~instant-match-catalog~c6e2eefa":"active-tournament-catalog~app-layout~homeshop-tournament~instant-match-catalog~instant-match-catalog~c6e2eefa","active-tournament-catalog":"active-tournament-catalog","app-layout~instant-match-details-layout~invite~tournament-details-lfg~tournament-layout":"app-layout~instant-match-details-layout~invite~tournament-details-lfg~tournament-layout","app-layout~invite":"app-layout~invite","app-layout~match-room":"app-layout~match-room","app-layout":"app-layout","homeshop-tournament":"homeshop-tournament","instant-match-catalog~instant-match-catalog-mobile":"instant-match-catalog~instant-match-catalog-mobile","instant-match-catalog-mobile":"instant-match-catalog-mobile","instant-match-catalog~instant-match-details-layout~landing~tournament-layout":"instant-match-catalog~instant-match-details-layout~landing~tournament-layout","instant-match-catalog":"instant-match-catalog","landing":"landing","instant-match-details":"instant-match-details","instant-match-details-layout~invite~tournament-details-lfg~tournament-form~tournament-layout":"instant-match-details-layout~invite~tournament-details-lfg~tournament-form~tournament-layout","invite":"invite","instant-match-details-layout":"instant-match-details-layout","tournament-layout":"tournament-layout","tournament-details-lfg":"tournament-details-lfg","instant-match-layout":"instant-match-layout","overlay-member-profile":"overlay-member-profile","overlay-tournament-catalog":"overlay-tournament-catalog","overlay-tournament-details":"overlay-tournament-details","recent-tournament-catalog":"recent-tournament-catalog","tournament-bracket~tournament-details-bracket":"tournament-bracket~tournament-details-bracket","tournament-details-bracket":"tournament-details-bracket","tournament-details-overview":"tournament-details-overview","tournament-details-rule":"tournament-details-rule","tournament-details-teams":"tournament-details-teams","upcoming-tournament-catalog":"upcoming-tournament-catalog","auth-callback":"auth-callback","campaign-layout":"campaign-layout","campaign-view":"campaign-view","catalog-layout":"catalog-layout","draft-layout":"draft-layout","draft-session-league-view~match-room":"draft-session-league-view~match-room","draft-session-league-view":"draft-session-league-view","draft-session-wild-rift-view~match-room":"draft-session-wild-rift-view~match-room","match-room":"match-room","draft-session-wild-rift-view":"draft-session-wild-rift-view","homeshop-layout":"homeshop-layout","homeshop-my":"homeshop-my","homeshop-other":"homeshop-other","homeshop-player":"homeshop-player","tournament-form":"tournament-form","match-room-layout":"match-room-layout","member-layout~member-match-history~member-tournament-history":"member-layout~member-match-history~member-tournament-history","member-layout":"member-layout","member-match-history":"member-match-history","member-tournament-history":"member-tournament-history","member-verify":"member-verify","payment-layout":"payment-layout","payment-transaction":"payment-transaction","top-tournament-catalog":"top-tournament-catalog","tournament-bracket":"tournament-bracket"}[chunkId]||chunkId) + "." + {"active-tournament-catalog~app-layout~homeshop-tournament~instant-match-catalog~instant-match-catalog~c6e2eefa":"356d7615","active-tournament-catalog":"959e5d71","app-layout~instant-match-details-layout~invite~tournament-details-lfg~tournament-layout":"d5bead94","app-layout~invite":"7adb4ca9","app-layout~match-room":"db4f5ac9","app-layout":"182c5ffd","homeshop-tournament":"8616d1d8","instant-match-catalog~instant-match-catalog-mobile":"e63e4c3c","instant-match-catalog-mobile":"dfaf39c9","instant-match-catalog~instant-match-details-layout~landing~tournament-layout":"fd1a0f26","instant-match-catalog":"72c13880","landing":"4bdbf7f1","instant-match-details":"98c9902c","instant-match-details-layout~invite~tournament-details-lfg~tournament-form~tournament-layout":"3bd4b310","invite":"f9f90f34","instant-match-details-layout":"65932219","tournament-layout":"ef09a970","tournament-details-lfg":"de2b2c28","instant-match-layout":"efe3f98f","overlay-member-profile":"1519ea30","overlay-tournament-catalog":"9192ef02","overlay-tournament-details":"b9b0d37d","recent-tournament-catalog":"90accaff","tournament-bracket~tournament-details-bracket":"ce100844","tournament-details-bracket":"6e0d4cbb","tournament-details-overview":"d0bec417","tournament-details-rule":"968b5e29","tournament-details-teams":"3236c210","upcoming-tournament-catalog":"f42fe74a","auth-callback":"7c5a301b","campaign-layout":"7443f354","campaign-view":"7b9c087f","catalog-layout":"e35c308d","chunk-2d0b214b":"05c39437","draft-layout":"dcbf704e","draft-session-league-view~match-room":"528f77d4","draft-session-league-view":"9f177930","draft-session-wild-rift-view~match-room":"f383692d","match-room":"983f9386","draft-session-wild-rift-view":"5d145c7d","homeshop-layout":"579e0247","homeshop-my":"ab1008b5","homeshop-other":"0ddb3a2a","homeshop-player":"d2fe223b","tournament-form":"96093ed8","match-room-layout":"2260e077","member-layout~member-match-history~member-tournament-history":"e3af51b0","member-layout":"d5d674ae","member-match-history":"66f8059c","member-tournament-history":"3ad0b61c","member-verify":"7d4d7454","payment-layout":"a4c2b948","payment-transaction":"33f630f7","top-tournament-catalog":"ad2cac98","tournament-bracket":"57052d27"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"active-tournament-catalog":1,"app-layout~instant-match-details-layout~invite~tournament-details-lfg~tournament-layout":1,"app-layout~invite":1,"app-layout~match-room":1,"app-layout":1,"homeshop-tournament":1,"instant-match-catalog~instant-match-catalog-mobile":1,"instant-match-catalog-mobile":1,"instant-match-catalog":1,"landing":1,"instant-match-details":1,"invite":1,"instant-match-details-layout":1,"tournament-layout":1,"tournament-details-lfg":1,"instant-match-layout":1,"overlay-member-profile":1,"overlay-tournament-catalog":1,"overlay-tournament-details":1,"recent-tournament-catalog":1,"tournament-bracket~tournament-details-bracket":1,"tournament-details-bracket":1,"tournament-details-overview":1,"tournament-details-rule":1,"tournament-details-teams":1,"upcoming-tournament-catalog":1,"catalog-layout":1,"draft-session-league-view~match-room":1,"draft-session-wild-rift-view~match-room":1,"match-room":1,"homeshop-layout":1,"homeshop-my":1,"homeshop-other":1,"tournament-form":1,"match-room-layout":1,"member-layout~member-match-history~member-tournament-history":1,"member-layout":1,"member-match-history":1,"member-tournament-history":1,"payment-layout":1,"payment-transaction":1,"top-tournament-catalog":1,"tournament-bracket":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"active-tournament-catalog~app-layout~homeshop-tournament~instant-match-catalog~instant-match-catalog~c6e2eefa":"active-tournament-catalog~app-layout~homeshop-tournament~instant-match-catalog~instant-match-catalog~c6e2eefa","active-tournament-catalog":"active-tournament-catalog","app-layout~instant-match-details-layout~invite~tournament-details-lfg~tournament-layout":"app-layout~instant-match-details-layout~invite~tournament-details-lfg~tournament-layout","app-layout~invite":"app-layout~invite","app-layout~match-room":"app-layout~match-room","app-layout":"app-layout","homeshop-tournament":"homeshop-tournament","instant-match-catalog~instant-match-catalog-mobile":"instant-match-catalog~instant-match-catalog-mobile","instant-match-catalog-mobile":"instant-match-catalog-mobile","instant-match-catalog~instant-match-details-layout~landing~tournament-layout":"instant-match-catalog~instant-match-details-layout~landing~tournament-layout","instant-match-catalog":"instant-match-catalog","landing":"landing","instant-match-details":"instant-match-details","instant-match-details-layout~invite~tournament-details-lfg~tournament-form~tournament-layout":"instant-match-details-layout~invite~tournament-details-lfg~tournament-form~tournament-layout","invite":"invite","instant-match-details-layout":"instant-match-details-layout","tournament-layout":"tournament-layout","tournament-details-lfg":"tournament-details-lfg","instant-match-layout":"instant-match-layout","overlay-member-profile":"overlay-member-profile","overlay-tournament-catalog":"overlay-tournament-catalog","overlay-tournament-details":"overlay-tournament-details","recent-tournament-catalog":"recent-tournament-catalog","tournament-bracket~tournament-details-bracket":"tournament-bracket~tournament-details-bracket","tournament-details-bracket":"tournament-details-bracket","tournament-details-overview":"tournament-details-overview","tournament-details-rule":"tournament-details-rule","tournament-details-teams":"tournament-details-teams","upcoming-tournament-catalog":"upcoming-tournament-catalog","auth-callback":"auth-callback","campaign-layout":"campaign-layout","campaign-view":"campaign-view","catalog-layout":"catalog-layout","draft-layout":"draft-layout","draft-session-league-view~match-room":"draft-session-league-view~match-room","draft-session-league-view":"draft-session-league-view","draft-session-wild-rift-view~match-room":"draft-session-wild-rift-view~match-room","match-room":"match-room","draft-session-wild-rift-view":"draft-session-wild-rift-view","homeshop-layout":"homeshop-layout","homeshop-my":"homeshop-my","homeshop-other":"homeshop-other","homeshop-player":"homeshop-player","tournament-form":"tournament-form","match-room-layout":"match-room-layout","member-layout~member-match-history~member-tournament-history":"member-layout~member-match-history~member-tournament-history","member-layout":"member-layout","member-match-history":"member-match-history","member-tournament-history":"member-tournament-history","member-verify":"member-verify","payment-layout":"payment-layout","payment-transaction":"payment-transaction","top-tournament-catalog":"top-tournament-catalog","tournament-bracket":"tournament-bracket"}[chunkId]||chunkId) + "." + {"active-tournament-catalog~app-layout~homeshop-tournament~instant-match-catalog~instant-match-catalog~c6e2eefa":"31d6cfe0","active-tournament-catalog":"efdec479","app-layout~instant-match-details-layout~invite~tournament-details-lfg~tournament-layout":"f230f9cd","app-layout~invite":"5877b5f3","app-layout~match-room":"5a28127a","app-layout":"082f8229","homeshop-tournament":"bf187566","instant-match-catalog~instant-match-catalog-mobile":"407aabae","instant-match-catalog-mobile":"b0bba621","instant-match-catalog~instant-match-details-layout~landing~tournament-layout":"31d6cfe0","instant-match-catalog":"7a64f277","landing":"7ebe1daa","instant-match-details":"6b19af3b","instant-match-details-layout~invite~tournament-details-lfg~tournament-form~tournament-layout":"31d6cfe0","invite":"53ff6f7c","instant-match-details-layout":"062e4ffe","tournament-layout":"a73bdd03","tournament-details-lfg":"047115e9","instant-match-layout":"7f29ef0d","overlay-member-profile":"8c44f7ea","overlay-tournament-catalog":"3e37425d","overlay-tournament-details":"4c9817d9","recent-tournament-catalog":"e0188447","tournament-bracket~tournament-details-bracket":"b170485e","tournament-details-bracket":"80a611ea","tournament-details-overview":"47f09b79","tournament-details-rule":"b579747a","tournament-details-teams":"fe89595a","upcoming-tournament-catalog":"c283d756","auth-callback":"31d6cfe0","campaign-layout":"31d6cfe0","campaign-view":"31d6cfe0","catalog-layout":"0a61c80d","chunk-2d0b214b":"31d6cfe0","draft-layout":"31d6cfe0","draft-session-league-view~match-room":"5ae7413c","draft-session-league-view":"31d6cfe0","draft-session-wild-rift-view~match-room":"8566f8cd","match-room":"9c7cad30","draft-session-wild-rift-view":"31d6cfe0","homeshop-layout":"2d86d875","homeshop-my":"d67f75f0","homeshop-other":"386b621c","homeshop-player":"31d6cfe0","tournament-form":"02ea7398","match-room-layout":"6ded7229","member-layout~member-match-history~member-tournament-history":"4520e629","member-layout":"bb09b03a","member-match-history":"f88e3570","member-tournament-history":"5ede7b8d","member-verify":"31d6cfe0","payment-layout":"e1ea4e7b","payment-transaction":"e0b908e8","top-tournament-catalog":"3e75b6be","tournament-bracket":"19586b56"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
